import * as React from "react";
import { SVGProps, memo } from "react";

const SvgLight = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 18.333a1.63 1.63 0 0 1-1.198-.49 1.63 1.63 0 0 1-.49-1.197h3.376c0 .472-.164.871-.49 1.198a1.63 1.63 0 0 1-1.198.49Zm-2.75-2.979a.603.603 0 0 1-.445-.18.61.61 0 0 1-.18-.448.61.61 0 0 1 .625-.621h5.5c.177 0 .325.06.445.18s.18.27.18.448-.06.326-.18.444a.61.61 0 0 1-.445.177h-5.5Zm-.52-2.52a6.836 6.836 0 0 1-2.178-2.24c-.535-.896-.802-1.906-.802-3.031 0-1.695.618-3.16 1.854-4.396C6.84 1.93 8.306 1.313 10 1.313s3.16.618 4.396 1.854c1.236 1.236 1.854 2.701 1.854 4.396 0 1.125-.264 2.135-.792 3.03-.527.897-1.257 1.643-2.187 2.24H6.729Zm.457-1.25h5.64a4.825 4.825 0 0 0 1.59-1.732c.389-.71.583-1.474.583-2.29 0-1.375-.49-2.552-1.469-3.53-.979-.98-2.156-1.47-3.531-1.47s-2.552.49-3.531 1.47C5.489 5.01 5 6.186 5 7.561c0 .816.194 1.58.583 2.29.39.71.924 1.287 1.604 1.731Z"
      fill="#E98E16"
    />
  </svg>
);

const Memo = memo(SvgLight);

export default Memo;
